import React, {Fragment} from "react";
import { Buffer } from "buffer";
import { environment } from "../../utils/environment";
import { getCodeSession } from "../../utils/session";

//TODO: Remove the redirects comments
export default class LoginGuard extends React.PureComponent {
  componentDidMount(): void {
    const loginWhitelist = [ "/anon", "/genericAnon", "/code" ];

    if (loginWhitelist.includes(window.location.pathname))
      return;

    const token = localStorage.getItem("AccessToken");
    if(!token) {
      const authData = environment.auth;
      const clientId = encodeURIComponent(authData.clientId);
      const redirectUrl = encodeURIComponent(authData.redirectUrl);
      const state = encodeURIComponent(
        Buffer.from(
          JSON.stringify({
            url: window.location.href
          })
        ).toString("base64")
      );
      const url = decodeURIComponent(`${environment.auth.baseUrl}/?clientId=${clientId}&redirectUrl=${redirectUrl}&state=${state}`);
      window.location.href = url;
    }
  }

  render() {
    return (<Fragment />);
  }
}

/**
 * Ends the session. Every screen's `applicationShouldLogout` funnels here, so
 * this is the one place that decides where a dead session lands.
 *
 * A code session must NOT land on the auth-fe login: that screen asks for a
 * password the person never created. It goes back to the code screen instead,
 * carrying the invitation uid read from the dying token's own claims — the
 * answers are already saved server-side, so re-entering the code resumes the
 * coleta. Read the claims BEFORE clearing storage, or the uid is gone.
 *
 * Only the browser forgets anything here: the access code stays valid in the
 * database until its due date, and nothing revokes the JWT itself.
 *
 * @param expired why the session is ending. Defaults to true because the many
 * `applicationShouldLogout` callers are all forced exits; the one deliberate
 * caller — the header menu — passes false, so the code screen does not tell
 * someone who chose to leave that their session expired.
 */
export function logout({ expired = true }: { expired?: boolean } = {}) {
  const codeSession = getCodeSession();

  localStorage.removeItem("AccessToken");
  localStorage.removeItem("RefreshToken");

  if (codeSession) {
    const query = new URLSearchParams({ invitation: codeSession.uid });
    if (expired) query.set("expired", "1");
    window.location.href = `${environment.baseUrl}/code?${query.toString()}`;
    return;
  }

  const authData = environment.auth;
  const clientId = encodeURIComponent(authData.clientId);
  const redirectUrl = encodeURIComponent(authData.redirectUrl);
  const url = decodeURIComponent(`${environment.auth.baseUrl}/logout?clientId=${clientId}&redirectUrl=${redirectUrl}`);
  window.location.href = url;
}
